<div [class]="classes">
    <div [class]="iconClass"></div>

    <div class="content">
        <div class="title">{{ resolvedTitle }}</div>
        <div class="description">{{ resolvedDescription }}</div>
    </div>

    <button *ngIf="showCloseButton" class="icon icon-close" (click)="closeClicked.emit()"></button>
</div>
